<div class="footer-onboarding-root" *transloco="let t">
  <div class="logos">
    <div class="lnr-logo" title="{{t('epson-logo-alt')}}"></div>
    <div class="epson-logo-onboarding">EPSON</div>
  </div>
  <div class="copyright">
    <p>{{t('copyright')}}</p>
    <div>
      <a href="{{privacyPolicyLink}}" target="_blank" rel="noopener"
        >{{t('privacy-policy')}}</a
      >
      |
      <a
        href="{{termsAndConditionsLink}}"
        target="_blank"
        rel="noopener"
        >{{t('terms-conditions')}}</a
      >
    </div>
  </div>
</div>
